import { agencyContract } from "./features/agency/contract";
import { analyticsContract } from "./features/analytics/contract";
import { auditLogContract } from "./features/audit-log/contract";
import { authContract } from "./features/auth/contract";
import { clientContract } from "./features/client/contract";
import { discountCodeContract } from "./features/discount-code/contract";
import { employeeContract } from "./features/employee/contract";
import { financeContract } from "./features/finance/contract";
import { reservationContract } from "./features/reservation/contract";
import { roleContract } from "./features/role/contract";
import { tripContract } from "./features/trip/contract";
import { withdrawalContract } from "./features/withdrawal/contract";
import { OC } from "./utils";

export const AdminAPIContract = OC.router({
  trip: tripContract,
  agency: agencyContract,
  auth: authContract,
  reservation: reservationContract,
  client: clientContract,
  employee: employeeContract,
  role: roleContract,
  analytics: analyticsContract,
  finance: financeContract,
  auditLog: auditLogContract,
  discountCode: discountCodeContract,
  withdrawal: withdrawalContract,
});
export type AdminAPIContract = typeof AdminAPIContract;
